import { ssFetchJSON } from '../../ssFetch';

export const getUserExistsResponse = (userEmail: string) => ssFetchJSON(`/accounts/user-exists?email=${encodeURIComponent(userEmail)}`, {
  method: 'GET',
});
